import { useQuery } from '@tanstack/react-query';
import { getNotification } from '../api/api';
import { API_URLS_ENTITY } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';

interface IFetchNewNotificationCount {
  to?: string;
  from?: string;
}
export const useFetchNewNotificationCount = (params: IFetchNewNotificationCount) => {
  const queryString = Object.keys(params)?.length
    ? toQueryString(params as QueryParamObject)
    : null;
  const url = `${API_URLS_ENTITY.NOTIFICATIONS.COUNT_UNREAD}?${queryString}`;
  const query = useQuery<number, Error>({
    queryKey: ['notifications-count', params],
    queryFn: async () => {
      const response = await getNotification(url);
      return response;
    },
    enabled: !!params.from && !!params.to,
    refetchInterval: 20000,
  });

  return query;
};
